"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const Label = ({
  className,
  children,
  ...additionalProps
}) => {
  const classes = (0, _classnames.default)('Label', className);
  return /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({
    className: classes
  }, additionalProps), children);
};
var _default = exports.default = Label;